export const statusCode = {
    EMAIL_ALREADY_EXISTS : 5001,
    TELEPHONE_ALREADY_EXISTS : 5002,
    MRN_ALREADY_EXISTS : 5003,
    REQUEST_ACCEPTANCE_LIMIT_REACHED : 5004,
    OUTDATED_DATA : 5005,
}